import { render } from "./UpdatePassword.vue?vue&type=template&id=cd82b356"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"
script.render = render

export default script